/**
 * Checks if provided object/array is empty
 * 
 * @param {Object} variable - variable to check if is set
 * @return {boolean}
 */
export default (variable) => {
  if (Array.isArray(variable) && variable.length) {
    return false;
  }
  if (
    typeof variable === "object" &&
    variable !== null &&
    !Array.isArray(variable) &&
    Object.keys(variable).length
  ) {
    return false;
  }

  return true;
};
